import React, { useState, useEffect, useRef, Fragment } from "react";
import { Form, FormGroup, Input, Button, Row, Col, Card, CardHeader, CardBody, Nav, NavItem, NavLink, Badge } from "reactstrap";
import classnames from "classnames";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";
import { NumberFormatInput } from "../../../NumberFormatInput/NumberFormatInput";
import { KYCStatus, KYCReason } from "../types";
import { CustomFormInput, SelectFormField, FormField } from "../../../../utils/FormFields";
import { CircularProgress } from "../../../..";
import { AccountMode, PersonMode, showToast } from "../../../../utils/Helper";
import { parseDate } from "./../../../../utils/dateUtils";
import ChangesPanel from "../../../Modal/Alert/Items/ChangesPanel";
import FollowUpTimeline from "../../../Modal/Alert/Items/FollowUpTimeline";

const KYC_SUB_TABS = {
  Data: "data",
  Changes: "changes",
  FollowUp: "followup",
};

const KYCTab = ({
  KYC,
  person,
  setPersonData,
  services,
  onboarding,
  mode,
  role,
  refresh,
  isKYCRiskUpdateEnabled,
  kycSource,
  changesCount,
  changesData,
  changesFetchs,
  alertEventId,
  currentUser,
}) => {
  const [kycSubTab, setKycSubTab] = useState(KYC_SUB_TABS.Data);
  const [loadingSave, setLoadingSave] = useState(false);
  const [changedKYC, setChangedKYC] = useState({});

  const [initialstatus, setInitial] = useState("New");

  const handleSave = () => {
    const sendKYC = { ...KYC, ...changedKYC };

    const postPerson = {
      ...person,
      KYC: sendKYC,
    };
    const body = {
      OnboardingId: onboarding,
      postPerson: postPerson,
    };

    setLoadingSave(true);
    if (mode === PersonMode.New) {
      services.fetchNewPerson(body, (res) => {
        if (res) {
          setPersonData({
            ...postPerson,
          });
          setChangedKYC({});
          setLoadingSave(false);
          showToast("Changes saved successfully");
          refresh();
        } else {
          setLoadingSave(false);
        }
      });
    } else {
      const updatedPerson = {
        ...postPerson, 
        isOnboardingPerson: person.isOnboardingPerson,
      };
      services.fetchPersonKYC({ person: updatedPerson }, ({ result }) => {
        if (result && result.Code === 200) {
          setPersonData(
            {
              ...person,
              KYC: changedKYC,
            },
            true
          );
          setChangedKYC({});
          setLoadingSave(false);
          refresh();
        } else {
          setLoadingSave(false);
        }
      });
    }
  };

  const onChange = (name, value) => {
    if (!loadingSave) {
      const newKYC = { ...changedKYC };
      if (KYC[name] !== value) {
        newKYC[name] = value;
      } else if (newKYC[name]) {
        newKYC[name] = undefined;
      }
      setChangedKYC(newKYC);
    }
  };

  const revert = () => setChangedKYC({});

  if (!KYC) {
    return <CircularProgress sm />;
  }

  const renderKYCContent = () => (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          {isKYCRiskUpdateEnabled ? (
            <React.Fragment>
              <div
                style={{
                  border: "1px solid #d6d6d6",
                  borderRadius: "8px",
                  backgroundColor: "#f8f9fa",
                  padding: "16px",
                  marginBottom: "16px",
                }}
              >
                <Row>
                  <Col>
                    <SelectFormField
                      disabled={true}
                      label="Politically exposed person"
                      value={changedKYC.KYCPersonIsPEP || KYC.KYCPersonIsPEP}
                      name="KYCPersonIsPEP"
                      onChange={onChange}
                      selectItems={[true, false]}
                      getSelectItemId={(i) => i}
                      getSelectItemName={(i) => (i ? "Yes" : "No")}
                    />
                  </Col>
                  <Col>
                    <CustomFormInput label="Nationality">
                      <Input
                        disabled={true}
                        value={
                          changedKYC.KYCPersonNationality || changedKYC.KYCPersonNationality === ""
                            ? changedKYC.KYCPersonNationality
                            : KYC.KYCPersonNationality
                        }
                        onChange={(e) => onChange("KYCPersonNationality", e.target.value)}
                      />
                    </CustomFormInput>
                  </Col>
                  <Col>
                    <CustomFormInput label="Type">
                      <Input
                        disabled={true}
                        value={
                          changedKYC.KYCPersonType || changedKYC.KYCPersonType === ""
                            ? changedKYC.KYCPersonType
                            : KYC.KYCPersonType
                        }
                        onChange={(e) => onChange("KYCPersonType", e.target.value)}
                      />
                    </CustomFormInput>
                  </Col>
                  <Col>
                    <CustomFormInput label="Age">
                      <NumberFormatInput
                        disabled={true}
                        type="text"
                        customInput={Input}
                        value={
                          changedKYC.KYCPersonAge || changedKYC.KYCPersonAge === ""
                            ? changedKYC.KYCPersonAge
                            : KYC.KYCPersonAge
                        }
                        onValueChange={(e) => onChange("KYCPersonAge", e.value)}
                        dataTypeDecimalName="default"
                      />
                    </CustomFormInput>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <CustomFormInput label="Activity">
                      <Input
                        disabled={true}
                        type="text"
                        value={
                          changedKYC.KYCPersonActivity || changedKYC.KYCPersonActivity === ""
                            ? changedKYC.KYCPersonActivity
                            : KYC.KYCPersonActivity
                        }
                        onChange={(e) => onChange("KYCPersonActivity", e.target.value)}
                      />
                    </CustomFormInput>
                  </Col>
                  <Col>
                    <CustomFormInput label="Address">
                      <Input
                        disabled={true}
                        type="text"
                        value={
                          changedKYC.KYCPersonAddress || changedKYC.KYCPersonAddress === ""
                            ? changedKYC.KYCPersonAddress
                            : KYC.KYCPersonAddress
                        }
                        onChange={(e) => onChange("KYCPersonAddress", e.target.value)}
                      />
                    </CustomFormInput>
                  </Col>
                </Row>
                <Row></Row>
              </div>
              <Row>
                <Col>
                  <FormField
                    label="KYC Compliance Date: "
                    type="date"
                    value={
                      changedKYC.KYCValidatedDate || changedKYC.KYCValidatedDate == ""
                        ? parseDate(changedKYC.KYCValidatedDate)
                        : parseDate(KYC.KYCValidatedDate)
                    }
                    name="KYCValidatedDate"
                    onChange={onChange}
                    disabled={role !== "Compliance"}
                  />
                </Col>
                <Col>
                  <FormField
                    label="KYC Matured Date: "
                    type="date"
                    value={
                      changedKYC.KYCMaturedDate || changedKYC.KYCMaturedDate === ""
                        ? parseDate(changedKYC.KYCMaturedDate)
                        : parseDate(KYC.KYCMaturedDate)
                    }
                    name="KYCMaturedDate"
                    onChange={onChange}
                    disabled={true}
                  />
                </Col>
                <Col>
                  <FormField
                    label="KYC Advisor Date: "
                    type="date"
                    value={
                      changedKYC.KYCDate || changedKYC.KYCDate === ""
                        ? parseDate(changedKYC.KYCDate)
                        : parseDate(KYC.KYCDate)
                    }
                    name="KYCDate"
                    onChange={onChange}
                    disabled={role !== "Advisor"}
                  />
                </Col>
                <Col>
                  <SelectFormField
                    label="KYC Status: "
                    value={
                      changedKYC.KYCStatus === "" && KYC.KYCStatus === ""
                        ? initialstatus
                        : changedKYC.KYCStatus
                        ? changedKYC.KYCStatus
                        : KYC.KYCStatus
                    }
                    name="KYCStatus"
                    selectItems={Object.keys(KYCStatus)}
                    getSelectItemId={(i) => i}
                    getSelectItemName={(i) => KYCStatus[i]}
                    onChange={onChange}
                    disabled={role !== "Compliance" || isKYCRiskUpdateEnabled === true}
                  />
                </Col>
                <Col>
                  <SelectFormField
                    label="KYC Reason: "
                    value={
                      changedKYC.KYCReason === "" && KYC.KYCReason === ""
                        ? initialstatus
                        : changedKYC.KYCReason
                        ? changedKYC.KYCReason
                        : KYC.KYCReason
                    }
                    name="KYCReason"
                    selectItems={Object.keys(KYCReason)}
                    getSelectItemId={(i) => i}
                    getSelectItemName={(i) => KYCReason[i]}
                    onChange={onChange}
                    disabled={role === "BackOffice" || isKYCRiskUpdateEnabled === true}
                  />
                </Col>
              </Row>
              <CustomFormInput label="Advisor summary: ">
                <Input
                  type="textarea"
                  value={
                    changedKYC.KYCAdvisorComments || changedKYC.KYCAdvisorComments === ""
                      ? changedKYC.KYCAdvisorComments
                      : KYC.KYCAdvisorComments
                  }
                  onChange={(e) => onChange("KYCAdvisorComments", e.target.value)}
                  disabled={role !== "Advisor"}
                />
              </CustomFormInput>
              <CustomFormInput label="Compliance summary: ">
                <Input
                  type="textarea"
                  value={
                    changedKYC.KYCValidateComments || changedKYC.KYCValidateComments === ""
                      ? changedKYC.KYCValidateComments
                      : KYC.KYCValidateComments
                  }
                  onChange={(e) => onChange("KYCValidateComments", e.target.value)}
                  disabled={role !== "Compliance"}
                />
              </CustomFormInput>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Row>
                <Col>
                  <CustomFormInput label="Person Name">
                    <Input
                      disabled={true}
                      value={
                        changedKYC.KYCPersonName || changedKYC.KYCPersonName === ""
                          ? changedKYC.KYCPersonName
                          : KYC.KYCPersonName
                      }
                      onChange={(e) => onChange("KYCPersonName", e.target.value)}
                    />
                  </CustomFormInput>
                </Col>
                <Col>
                  <CustomFormInput label="Person Document Number ">
                    <Input
                      disabled={true}
                      value={
                        changedKYC.KYCPersonDocumentNumber || changedKYC.KYCPersonDocumentNumber === ""
                          ? changedKYC.KYCPersonDocumentNumber
                          : KYC.KYCPersonDocumentNumber
                      }
                      onChange={(e) => onChange("KYCPersonDocumentNumber", e.target.value)}
                    />
                  </CustomFormInput>
                </Col>

                <Col>
                  <SelectFormField
                    disabled={true}
                    label="Person is PEP: "
                    value={changedKYC.KYCPersonIsPEP || KYC.KYCPersonIsPEP}
                    name="KYCPersonIsPEP"
                    onChange={onChange}
                    selectItems={[true, false]}
                    getSelectItemId={(i) => i}
                    getSelectItemName={(i) => (i ? "Yes" : "No")}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <CustomFormInput label="Person Nationality ">
                    <Input
                      disabled={true}
                      value={
                        changedKYC.KYCPersonNationality || changedKYC.KYCPersonNationality === ""
                          ? changedKYC.KYCPersonNationality
                          : KYC.KYCPersonNationality
                      }
                      onChange={(e) => onChange("KYCPersonNationality", e.target.value)}
                    />
                  </CustomFormInput>
                </Col>
                <Col>
                  <CustomFormInput label="Person Type ">
                    <Input
                      disabled={true}
                      value={
                        changedKYC.KYCPersonType || changedKYC.KYCPersonType === ""
                          ? changedKYC.KYCPersonType
                          : KYC.KYCPersonType
                      }
                      onChange={(e) => onChange("KYCPersonType", e.target.value)}
                    />
                  </CustomFormInput>
                </Col>
              </Row>
              <Row>
                <Col>
                  <CustomFormInput label="Person Age">
                    <NumberFormatInput
                      disabled={true}
                      type="text"
                      customInput={Input}
                      value={
                        changedKYC.KYCPersonAge || changedKYC.KYCPersonAge === ""
                          ? changedKYC.KYCPersonAge
                          : KYC.KYCPersonAge
                      }
                      onValueChange={(e) => onChange("KYCPersonAge", e.value)}
                      dataTypeDecimalName="default"
                    />
                  </CustomFormInput>
                </Col>
                <Col>
                  <CustomFormInput label="Person Activity">
                    <Input
                      disabled={true}
                      type="text"
                      value={
                        changedKYC.KYCPersonActivity || changedKYC.KYCPersonActivity === ""
                          ? changedKYC.KYCPersonActivity
                          : KYC.KYCPersonActivity
                      }
                      onChange={(e) => onChange("KYCPersonActivity", e.target.value)}
                    />
                  </CustomFormInput>
                </Col>
                <Col>
                  <CustomFormInput label="Person Address ">
                    <Input
                      disabled={true}
                      type="text"
                      value={
                        changedKYC.KYCPersonAddress || changedKYC.KYCPersonAddress === ""
                          ? changedKYC.KYCPersonAddress
                          : KYC.KYCPersonAddress
                      }
                      onChange={(e) => onChange("KYCPersonAddress", e.target.value)}
                    />
                  </CustomFormInput>
                </Col>
              </Row>
              <Row>
                <Col>
                  <CustomFormInput label="Person Risk ">
                    <Input
                      disabled={true}
                      type="text"
                      value={
                        changedKYC.KYCPersonRisk || changedKYC.KYCPersonRisk === ""
                          ? changedKYC.KYCPersonRisk
                          : KYC.KYCPersonRisk
                      }
                      onChange={(e) => onChange("KYCPersonRisk", e.target.value)}
                    />
                  </CustomFormInput>
                </Col>

                <Col>
                  <CustomFormInput label="Person Transactional Limit ">
                    <NumberFormatInput
                      disabled={true}
                      type="text"
                      customInput={Input}
                      value={KYC.KYCPersonTransactionalLimit}
                      onValueChange={(e) => onChange("KYCPersonTransactionalLimit", e.value)}
                      dataTypeDecimalName="currency"
                    />
                  </CustomFormInput>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormField
                    label="KYC Compliance Date: "
                    type="date"
                    value={
                      changedKYC.KYCValidatedDate || changedKYC.KYCValidatedDate == ""
                        ? parseDate(changedKYC.KYCValidatedDate)
                        : parseDate(KYC.KYCValidatedDate)
                    }
                    name="KYCValidatedDate"
                    onChange={onChange}
                    disabled={role !== "Compliance"}
                  />
                </Col>
                <Col>
                  <FormField
                    label="KYC Matured Date: "
                    type="date"
                    value={
                      changedKYC.KYCMaturedDate || changedKYC.KYCMaturedDate === ""
                        ? parseDate(changedKYC.KYCMaturedDate)
                        : parseDate(KYC.KYCMaturedDate)
                    }
                    name="KYCMaturedDate"
                    onChange={onChange}
                    disabled={true}
                  />
                </Col>
                <Col>
                  <FormField
                    label="KYC Advisor Date: "
                    type="date"
                    value={
                      changedKYC.KYCDate || changedKYC.KYCDate === ""
                        ? parseDate(changedKYC.KYCDate)
                        : parseDate(KYC.KYCDate)
                    }
                    name="KYCDate"
                    onChange={onChange}
                    disabled={role !== "Advisor"}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <SelectFormField
                    label="KYC Reason: "
                    value={
                      changedKYC.KYCReason === "" && KYC.KYCReason === ""
                        ? initialstatus
                        : changedKYC.KYCReason
                        ? changedKYC.KYCReason
                        : KYC.KYCReason
                    }
                    name="KYCReason"
                    selectItems={Object.keys(KYCReason)}
                    getSelectItemId={(i) => i}
                    getSelectItemName={(i) => KYCReason[i]}
                    onChange={onChange}
                    disabled={role === "BackOffice"}
                  />
                </Col>

                <Col>
                  <SelectFormField
                    label="KYC Status: "
                    value={
                      changedKYC.KYCStatus === "" && KYC.KYCStatus === ""
                        ? initialstatus
                        : changedKYC.KYCStatus
                        ? changedKYC.KYCStatus
                        : KYC.KYCStatus
                    }
                    name="KYCStatus"
                    selectItems={Object.keys(KYCStatus)}
                    getSelectItemId={(i) => i}
                    getSelectItemName={(i) => KYCStatus[i]}
                    onChange={onChange}
                    disabled={role !== "Compliance"}
                  />
                </Col>
              </Row>
              <CustomFormInput label="Advisor summary: ">
                <Input
                  type="textarea"
                  value={
                    changedKYC.KYCAdvisorComments || changedKYC.KYCAdvisorComments === ""
                      ? changedKYC.KYCAdvisorComments
                      : KYC.KYCAdvisorComments
                  }
                  onChange={(e) => onChange("KYCAdvisorComments", e.target.value)}
                  disabled={role !== "Advisor"}
                />
              </CustomFormInput>

              <CustomFormInput label="Compliance summary: ">
                <Input
                  type="textarea"
                  value={
                    changedKYC.KYCValidateComments || changedKYC.KYCValidateComments === ""
                      ? changedKYC.KYCValidateComments
                      : KYC.KYCValidateComments
                  }
                  onChange={(e) => onChange("KYCValidateComments", e.target.value)}
                  disabled={role !== "Compliance"}
                />
              </CustomFormInput>
            </React.Fragment>
          )}
          {onboarding && (
            <div>
              <CustomFormInput label="Status FROM External System: ">
                <Input
                  disabled={true}
                  type="textarea"
                  value={
                    changedKYC.KYCExternalStatus || changedKYC.KYCExternalStatus === ""
                      ? changedKYC.KYCExternalStatus
                      : KYC.KYCExternalStatus
                  }
                  onChange={(e) => onChange("KYCExternalStatus", e.target.value)}
                />
              </CustomFormInput>

              <CustomFormInput label="PLD FROM External System: ">
                <Input
                  disabled={true}
                  type="textarea"
                  value={changedKYC.IsPLD || changedKYC.IsPLD === "" ? changedKYC.IsPLD : KYC.IsPLD}
                  onChange={(e) => onChange("IsPLD", e.target.value)}
                />
              </CustomFormInput>
            </div>
          )}
          <CustomFormInput label="Flags FROM External System: ">
            <Input
              disabled={true}
              type="textarea"
              value={changedKYC.KYCFlags || changedKYC.KYCFlags === "" ? changedKYC.KYCFlags : KYC.KYCFlags}
              onChange={(e) => onChange("KYCFlags", e.target.value)}
            />
          </CustomFormInput>
        </FormGroup>
      </Form>
      {role !== "BackOffice" && (
        <Fragment>
          {mode !== PersonMode.New && (
            <Button style={{ marginRight: 10 }} disabled={loadingSave} onClick={() => revert()}>
              <i className="fa fa-undo" /> Revert
            </Button>
          )}
          <LaddaButton
            className="btn btn-ladda btn-primary"
            loading={loadingSave}
            disabled={Object.keys(changedKYC).length === 0}
            onClick={() => handleSave()}
            data-style={EXPAND_RIGHT}
          >
            Save
          </LaddaButton>
        </Fragment>
      )}
    </div>
  );

  if (kycSource === "kycChangeRequests") {
    return (
      <Card>
        <CardHeader>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: kycSubTab === KYC_SUB_TABS.Data })}
                onClick={() => setKycSubTab(KYC_SUB_TABS.Data)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-id-card-o" aria-hidden="true" /> Data
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: kycSubTab === KYC_SUB_TABS.Changes })}
                onClick={() => setKycSubTab(KYC_SUB_TABS.Changes)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-exchange" aria-hidden="true" /> Changes
                {changesCount > 0 && (
                  <Badge color="danger" pill style={{ marginLeft: 6 }}>
                    {changesCount}
                  </Badge>
                )}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: kycSubTab === KYC_SUB_TABS.FollowUp })}
                onClick={() => setKycSubTab(KYC_SUB_TABS.FollowUp)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-history" aria-hidden="true" /> Follow-up
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
        <CardBody>
          {kycSubTab === KYC_SUB_TABS.Data && renderKYCContent()}
          {kycSubTab === KYC_SUB_TABS.Changes && (
            changesData ? (
              <ChangesPanel
                info={changesData.info}
                changedCount={changesData.changedCount}
                riskResults={changesData.riskResults}
                riskLoading={changesData.riskLoading}
                advisorComments={changesData.advisorComments}
                complianceComments={changesData.complianceComments}
                alert={changesData.alert}
                alertEventId={alertEventId}
                role={role}
                fetchs={changesFetchs}
                currentUser={currentUser}
                transactionalProjection={changesData.transactionalProjection}
                onResolved={refresh}
              />
            ) : (
              <div style={{ padding: 24, textAlign: "center" }}>
                <CircularProgress sm />
              </div>
            )
          )}
          {kycSubTab === KYC_SUB_TABS.FollowUp && (
            <FollowUpTimeline
              events={(changesData && changesData.alert && changesData.alert.events) || []}
              downloadFile={changesFetchs && changesFetchs.downloadFile}
              fileTypesFetch={changesFetchs && changesFetchs.fileTypes}
              onSendFileType={changesFetchs && changesFetchs.setFileType}
              personType={changesData && changesData.alert && changesData.alert.personType}
            />
          )}
        </CardBody>
      </Card>
    );
  }

  return renderKYCContent();
};

KYCTab.propTypes = {
  KYC: PropTypes.object,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  mode: PropTypes.object.isRequired,
};

KYCTab.defaultProps = {
  KYC: undefined,
};

export default KYCTab;
